import { motion, AnimatePresence } from 'motion/react';

interface PopupTransitionProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  closeOnOutsideClick?: boolean;
}

const PopupTransition = ({ children, isOpen, onClose, closeOnOutsideClick = true }: PopupTransitionProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeOnOutsideClick ? onClose : undefined}
            className="fixed inset-0 z-999 mb-0 bg-black/50 pb-0 backdrop-blur-[2px]"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2 }}
            onClick={closeOnOutsideClick ? onClose : undefined}
            className="fixed inset-0 z-1000 flex items-center justify-center"
          >
            <div className="relative">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default PopupTransition;
